import { AssignmentInfo, Button, TravelInfo, Wrapper } from "components";
import { HeaderWithBack } from "components/HeaderBack";
import { useNavigate, useParams } from "react-router-dom";

import { ModalCancelTrip } from "components/Modal";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { cancelTripResponse, getTripRequest } from "services/trip-request";
import { RootState } from "store";
import styles from "./styles.module.scss";

export default function PendingPaymentPage() {
	const navigate = useNavigate();

	const { logged_user } = useSelector((state: RootState) => state.tokens);

	const { tripId } = useParams();
	const [trip, setTrip] = useState<any>({});
	const [tripDeparture, setTripDeparture] = useState("");
	const [tripArrival, setTripArrival] = useState("");
	const [confirmModal, setConfirmModal] = useState(false);

	const fetchData = async () => {
		if (!logged_user) return;

		getTripRequest(tripId)
			.then((apiTrip: any) => {
				setTrip(apiTrip);

				if (apiTrip.status !== "accepted") {
					navigate("/viagens");
					return;
				}

				const departureTrip = apiTrip?.points?.find(
					(point: any) => point.direction === "going" && point.type === "origin"
				);
				setTripDeparture(departureTrip.city);

				const arrivalTrip = apiTrip?.points?.find(
					(point: any) =>
						point.direction === "going" && point.type === "destination"
				);
				setTripArrival(arrivalTrip.city);
			})
			.catch((error) => {
				const message =
					"Algo saiu errado ao buscar os dados da viagem. Entre em contato com o suporte.";

				toast.error(message, {
					position: "bottom-center",
					autoClose: 5000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light"
				});

				navigate("/viagens");
			});
	};

	useEffect(() => {
		fetchData();
	}, []);

	const handleCancelTrip = async () => {
		await cancelTripResponse(tripId);
		navigate("/viagens");
	};

	return (
		<div className={styles.container}>
			<ModalCancelTrip
				open={confirmModal}
				onClose={() => setConfirmModal(false)}
				onAgree={() => handleCancelTrip()}
			/>
			<HeaderWithBack
				label={`${tripDeparture} → ${tripArrival}`}
				backTo={-1}
				className={styles.header}
			/>
			<Wrapper>
				<TravelInfo trip={trip} />

				<div className={styles.travelAssignment}>
					<span>Veículo e Motorista</span>
					<AssignmentInfo
						vehicle={trip.trip_response?.chosen_vehicle}
						driver={trip.trip_response?.chosen_driver}
					/>
				</div>

				<div className={styles.card}>
					<span>Aguardando pagamento</span>
					<span>
						Avisamos o cliente que você aceitou a viagem. Agora ele tem até
						dd/mm/aaaa para concluir o pagamento.
					</span>
				</div>

				<div className={styles.buttonWrapper}>
					<Button
						type="button"
						variant="outline"
						onClick={() => setConfirmModal(true)}
					>
						Cancelar viagem
					</Button>
				</div>
			</Wrapper>
		</div>
	);
}
